import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { Person } from '../../../core/model/central/person.model';

@Injectable()
export class PatientsActions {

    static searchPatientByPetName = createAction('[Patient:Search] Search Patient By Pet Name' , props<{searchPattern: string}>());

    static searchPatient = createAction('[Patient:Search] Search Patient' , props<{searchPattern: string}>());
    static searchPatientSuccess = createAction('[Patient:Search] Search Patient Success',
        props<{ patients: Array<any> }>());
    static searchPatientFail = createAction('[Patient:Search] Search Patient Fail',
        props<{ error: any }>());

    static getSelectedPatient = createAction('[Patient] Get Patient Details' , props<{personId: number}>());
    static getSelectedPatientSuccess = createAction('[Patient] Get Patient Details Success' , props<{selectedPatient: Person}>());
    static getSelectedPatientFail = createAction('[Patient] Get Patient Details Fail',
        props<{ error: any }>());

    static setPatientStrategy = createAction('[Patient:Strategy] Set Patient Strategy',
        props<{patientId: number, strategyId: number, estimated: boolean}>());

    static setPatientStrategyFail = createAction('[Patient:Strategy] Set Patient Strategy Fail',
        props<{error: any, patientId: number, strategyId: number}>());

    static getPatientByRemoteId = createAction('[Patient:Select] Get Patient By Remote Patient Id' , props<{remotePatientId: string}>());
    static getPatientByRemoteIdSuccess = createAction('[Patient] Get Patient By Remote Patient Id Success',
        props<{selectedPatient: Person}>());
    static getPatientByRemoteIdFail = createAction('[Patients] Get Patient By Remote Patient Id Fail',
        props<{ error: any }>());

    static refresh = createAction('[Patient:Refresh] Patient Refresh');

    static selectDestinator = createAction('[Patient:Destinator:UnSubscribe] Select Destinator for subscription settings ',
        props<{destinator: any}>());

    static openPatientSettings = createAction('[Patient:Settings] Open Patient Setting');

    static openPatientSettingCancel = createAction(
        '[Patient:Settings] Open Patient Setting Cancelled');

    static getPatientSettings =
        createAction('[Reminders:Patient:Settings] Get Patient Settings', props<{ userId: number }>());

    static getPatientSettingsSuccess = createAction('[Reminders:Patient:Settings] Get Patient Settings Success'
        , props<{ displayTwoway: boolean, displayBirthday: boolean, displayIncorrectDestinator: boolean, showProviders: boolean }>());

    static openSubscriptionsDialogFromLogs = createAction('[Logs:Subscription] Open Subscription Dialog (from Angular JS)',
        props<{selectedDestinator: string, selectedPatient: string}>());

    static openSubscriptionsDialogFromAngularJSSuccess =
        createAction('[Logs:Subscription] Open Subscription Dialog Success (from Angular JS)',
        props<{isSubscriptionUpdated: boolean}>());

    static openConfirmDialog = createAction(
        '[Patient:Strategy] Open Confirm Dialog',
        props<{dialogMessage: string, patientId: any, strategyId: any, okLabel: string, cancelLabel: string}>()
    );

    static openConfirmDialogCancel = createAction(
        '[Patient:Strategy] Open Confirm Dialog Cancelled');

}
